import script from "./ConfirmDeleteUser.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmDeleteUser.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmDeleteUser.vue?vue&type=style&index=0&id=0e4a4810&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e4a4810"]])

export default __exports__